module.exports = __webpack_public_path__ + "static/media/chrome-icon-192.2a193e9e.png";